export enum SrcName {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  TEST = "TEST",
}
